import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router-dom';
import "./header.scss"

import Text from '../typography/typgraphy';
import Popover from '../popover/popover';
import { getTransactionIdFromURL, isErrorPage, logoutUser } from '../../constants/utils';
import { EMAILID, FAQ, HELLO, LAST_LOGIN, LOGOUT, LOGOUT_MESSAGE, REMITTANCE } from '../../constants/messages';
import faqIcon from "../../assets/images/faq.svg";
import logoutIcon from "../../assets/images/logout.svg";
import profileIcon from "../../assets/images/profile.svg";
import { AxisLogoWhite } from '../../assets/svgs/svg';
import { ProfileDetailsState, initialState as emptyTransactionState } from '../../core/reducers/profileDetailsReducer';
import { FAQ_REDIRECTION_GA, PROFILE_DETAILS, PROFILE_LOGOUT_GA, pushDataLayer } from '../../constants/gaConstants';
import AxisButton from '../button/button';
import { useSelector } from 'react-redux';
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';
import { AuthState } from '../../core/reducers/authReducer';

interface IHeaderProps {
  isAuthenticated?: boolean;
  profileDetails: ProfileDetailsState;
  transactionDetails: TransactionState;
  partnerData: AuthState;
}

const Header: FunctionComponent<IHeaderProps | any> = (props) => {
  const { isAuthenticated, profileDetails, getProfileDetails , name, email, transactionDetails, partnerData} = props;
  const [anchorProfileEle, setAnchorProfileEle] = React.useState(null);
  const open = Boolean(anchorProfileEle);
  const id = open ? 'simple-popover' : undefined;
  const hideProfile = isErrorPage()
  const txnId = getTransactionIdFromURL()

  // TODO: Add error page redirection for Header Details API call
  const openProfilePopover = (event: any) => {
    pushDataLayer(PROFILE_DETAILS(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    if (isAuthenticated && (profileDetails === emptyTransactionState)) {
      getProfileDetails();
    }
    setAnchorProfileEle(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorProfileEle(null);
  };

  const handleFaqRedirect = () => {
    pushDataLayer(FAQ_REDIRECTION_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
  }

  const handleLogout = () => {
    pushDataLayer(PROFILE_LOGOUT_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    logoutUser()
  }

  const { lastLoginTime  } = useSelector((state) => state.transactionDetails);

  return (
    <React.Fragment>
      <div className={`${!isAuthenticated ? 'navbar-outer' : 'navbar-outer fixed-header'}`}>
        <div className="navbar-inner">
          <div className="logo-container">
            <AxisLogoWhite className="logo-img" height={50} width={150} />
            <Text className="logo-separator">|</Text>
            <Text className="logo-text" fontStyle={'italic'} fontSize={19} fontWeight={600}>{REMITTANCE}</Text>
          </div>
          {
            isAuthenticated && !hideProfile
              ? (
                <div className="account-container">
                  <img className="profile-icon" onClick={openProfilePopover} src={profileIcon} alt="profile" />
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorProfileEle}
                    onClose={handleClose}
                    anchorVerticalPos="bottom"
                    anchorHorizontalPos="left"
                    transformHorizontalPos="right"
                    transformVerticalPos="top"
                  >
                    <div className="popover-container">
                      <div className="popover-wrapper">
                        <div className="popover-item">
                          <Text fontSize={14} className="heading">{HELLO}</Text>
                          <Text className="description">{name.split(' ')[0].charAt(0).toUpperCase() + name.split(' ')[0].slice(1).toLowerCase()}</Text>
                        </div>
                        <div className="popover-item">
                          <Text fontSize={12} className="heading">{EMAILID.toLocaleUpperCase()}</Text>
                          <Text className="description">{email}</Text>
                        </div>
                        <div className="popover-item">
                          <Text fontSize={12} className="heading">{LAST_LOGIN.toLocaleUpperCase()}</Text>
                          <Text className="description">{lastLoginTime}</Text>
                        </div>
                        <div className="faq-section">
                          <AxisButton onClick={handleFaqRedirect} href={"https://campaign.axisbank.com/generic/remittance-faqs-17sept.pdf"} target="_blank" customStyle={"hyperlink-btn"}>
                            <div className="faq">
                              <img className="faq-icon" src={faqIcon} alt="faq" />
                              <Text className="faq-text">{FAQ}</Text>
                            </div>
                          </AxisButton>
                          <AxisButton onClick={handleFaqRedirect} customStyle={"hyperlink-btn"}>
                            <div className="faq" onClick={handleLogout}>
                              <img className="faq-icon" src={logoutIcon} alt="faq" />
                              <Text className="faq-text">{LOGOUT}</Text>
                            </div>
                          </AxisButton>
                        </div>
                        <Text className="logout-warning">{LOGOUT_MESSAGE}</Text>
                      </div>
                    </div>
                  </Popover>
                </div>
              )
              : null
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Header);
